module.exports = __webpack_public_path__ + "static/media/8.1.3.yandex_alisa_banner.3978f25b.png";